/**
 * 消费流水「费用类型」展示（与 FMC refType / type 字段约定一致）
 */
export function formatConsumptionChargeType(row) {
  if (!row) {
    return '';
  }
  const ref = (row.refType || '').toString();
  if (ref === 'monthly_bill_item' || ref === 'monthly_bill') {
    return '月度费用';
  }
  if (ref === 'admission_paid') {
    return '入院费用';
  }
  const remark = (row.remark || row.projectType || '').toString();
  if (remark.indexOf('月度扣费-') === 0) {
    return '月度费用';
  }
  const t = row.type;
  if (t === 0 || t === '0') {
    return '按天消费';
  }
  if (t === 1 || t === '1') {
    return '月度费用';
  }
  if (t === 3 || t === '3') {
    return '入院费用';
  }
  if (t === 2 || t === '2') {
    return '按次收费';
  }
  if (t === 5 || t === '5') {
    return '充值';
  }
  if (t === 6 || t === '6') {
    return '请假退费';
  }
  if (t === 7 || t === '7') {
    return '出院退费';
  }
  if (t === 8 || t === '8') {
    return '服务订单退费';
  }
  return '其他费用';
}
